import { render, staticRenderFns } from "./tapes_tabs.vue?vue&type=template&id=c81aa2bc&scoped=true&"
import script from "./tapes_tabs.vue?vue&type=script&lang=js&"
export * from "./tapes_tabs.vue?vue&type=script&lang=js&"
import style0 from "./tapes_tabs.vue?vue&type=style&index=0&id=c81aa2bc&scoped=true&lang=scss&"
import style1 from "./tapes_tabs.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c81aa2bc",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
import { VTabsSlider } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTab,VTabItem,VTabs,VTabsItems,VTabsSlider})


/* hot reload */
if (module.hot) {
  var api = require("/home/eu/public_ru/local/templates/international/int_site/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c81aa2bc')) {
      api.createRecord('c81aa2bc', component.options)
    } else {
      api.reload('c81aa2bc', component.options)
    }
    module.hot.accept("./tapes_tabs.vue?vue&type=template&id=c81aa2bc&scoped=true&", function () {
      api.rerender('c81aa2bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/main/tapes_tabs.vue"
export default component.exports